import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { InventoryService } from '../../services/index';

@Component({
  selector: 'app-itemmstr',
  templateUrl: './itemmstr.component.html',
  styleUrls: ['./itemmstr.component.scss'],
  providers:[InventoryService]
})
export class ItemmstrComponent implements OnInit {

  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  arritems:any=[];
  arrmjgrp:any=[];
  arrmngrp:any=[];
  itemmodel:any={};
  tab=1;

  status = [
    {
      id: 1,
      name: 'Active'
    },
    {
      id: 2,
      name: 'Inactive'
    }
 ];

  constructor(private iservice: InventoryService,private modalService: NgbModal) { }

  openmodal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit(): void {
    this.getinvmitem();
    this.getinvmiga();
    this.getinvmigb();

  }

  getinvmiga() {
    this.iservice.getinvmiga()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrmjgrp = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  getinvmigb() {
    this.iservice.getinvmigb()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrmngrp = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  getinvmitem() {
    this.iservice.getinvmitem()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arritems = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  opendialog(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.itemmodel={};
      this.itemmodel.icd=0;
      this.itemmodel.inm='';
      this.itemmodel.igida='';
      this.itemmodel.igidb='';
      this.itemmodel.hsn='';
      this.itemmodel.rol='';
      this.itemmodel.rstatus='Active';
      this.itemmodel.crby=localStorage.getItem('usid');
      this.itemmodel.mdby='0';
      this.itemmodel.oprtype='insert';
      

    }

    else if(cmd=='update')
    {
      this.itemmodel=objdata;
      this.itemmodel.mdby=localStorage.getItem('usid');
      this.itemmodel.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      //size:'sm'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  SaveDetails()
  {
console.log('catsave',this.itemmodel);
    this.iservice.saveinvmitem(this.itemmodel)
        .subscribe(
        result => {
            console.log('savelibcategory', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getinvmitem();
              //this.getlibcategory();

            }
           else
           {

           }
        },
        error =>{ alert('Error While saving...');}
        )
  }
}
